<div class="spacing-container">
  <div>
    <div id="confirmation-heading" class="medium">
      {{ cashoutTask.reference }}
    </div>

    <div class="list-container">
      <div *ngIf="cashoutTask.payeeName" class="list-row">
        <div class="icon-and-text">
          <img
            class="icons"
            src="assets/icons/Icon-User-Single-Black-No-Circle.svg"
            alt=""
          />
          <span
            class="medium2"
            i18n="@@viewCashoutTask.seller"
            >Seller</span
          >
        </div>
        <div>
          {{ cashoutTask.payeeName }}
        </div>
      </div>
      <div class="list-row">
        <div class="icon-and-text">
          <img class="icons" src="assets/icons/Icon-Phone.svg" alt="" />
          <span
            class="medium2"
            i18n="@@viewCashoutTask.mobileNumber"
            >Mobile number</span
          >
        </div>
        <div>
          <a href="tel:{{ cashoutTask.payeePhone }}" class="link">{{
            cashoutTask.payeePhone
          }}</a>
        </div>
      </div>
      <div
        class="list-row"
        [class.editingPadding]="editingAmount"
        [class.edit-amount-row]="
          cashoutTask.status === 'PENDING_EXECUTION' && !editingAmount
        "
        id="edit-amount-row"
      >
        <div class="icon-and-text">
          <img class="icons" src="assets/icons/Icon-Money-Wallet.svg" alt="" />
          <span
            class="medium2"
            i18n="@@viewCashoutTask.amount"
            >Amount</span
          >
        </div>

        <div *ngIf="cashoutTask.status !== 'PENDING_EXECUTION'">
          <span>{{
            cashoutTask.amount | currency: 'SEK ':'code':'1.2-2':'sv'
          }}</span>
        </div>

        <div *ngIf="cashoutTask.status === 'PENDING_EXECUTION'">
          <div *ngIf="!shouldDisplayEditAmountButton()">
            <span>{{
              cashoutTask.amount | currency: 'SEK ':'code':'1.2-2':'sv'
            }}</span>
          </div>

          <div
            *ngIf="!editingAmount && shouldDisplayEditAmountButton()"
            id="amount-edit"
          >
            <span>{{
              cashoutTask.amount | currency: 'SEK ':'code':'1.2-2':'sv'
            }}</span>
            <div
              *ngIf="shouldDisplayEditAmountButton()"
              class="hide-mobile-s"
              (click)="editAmount()"
            >
              <div id="edit-icon-div">
                <div id="edit-icon"></div>
              </div>
            </div>
          </div>
          <div *ngIf="editingAmount" id="amount-edit">
            <form [formGroup]="editAmountForm" novalidate>
              <input
                #amountInput
                type="text"
                inputmode="numeric"
                id="edit-amount-input"
                formControlName="amount"
              />
            </form>
          </div>
        </div>
      </div>
      <div class="list-row">
        <div class="icon-and-text">
          <img class="icons" src="assets/icons/Icon-Bank.svg" alt="" />
          <span
            class="medium2"
            i18n="@@viewCashoutTask.bankAccountNumber"
            >Bank account number</span
          >
        </div>
        <div>
          <span
            *ngIf="
              cashoutTask.bankAccount && cashoutTask.status !== 'CANCELLED'
            "
            >{{ cashoutTask.bankAccount }}</span
          >
          <span
            *ngIf="
              !cashoutTask.bankAccount || cashoutTask.status === 'CANCELLED'
            "
            >N/A</span
          >
        </div>
      </div>
      <div class="list-row" *ngIf="!cashoutTask.approvingRepresentativeName">
        <div class="icon-and-text">
          <img
            class="icons"
            src="assets/icons/Icon-User-Single-Black.svg"
            alt=""
          />
          <span
            class="medium2"
            i18n="@@viewCashoutTask.initializedBy"
            >Initialized by</span
          >
        </div>
        <div>
          {{ cashoutTask.initializingRepresentativeName }}
        </div>
      </div>
      <div class="list-row" *ngIf="cashoutTask.approvingRepresentativeName">
        <div class="icon-and-text">
          <img
            class="icons"
            src="assets/icons/Icon-User-Single-Black.svg"
            alt=""
          />
          <span
            class="medium2"
            i18n="@@viewCashoutTask.attestedBy"
            >Attested by</span
          >
        </div>
        <div>
          {{ cashoutTask.approvingRepresentativeName }}
        </div>
      </div>
      <div class="list-row" *ngIf="cashoutTask.executingRepresentativeName">
        <div class="icon-and-text">
          <img
            class="icons"
            src="assets/icons/Icon-User-Single-Black.svg"
            alt=""
          />
          <span
            class="medium2"
            i18n="@@viewCashoutTask.paidOutBy"
            >Paid out by</span
          >
        </div>
        <div>
          {{ cashoutTask.executingRepresentativeName }}
        </div>
      </div>
    </div>

    <div
      *ngIf="
        editingAmount &&
        editAmountForm.controls.amount.invalid &&
        showEditAmountError
      "
      class="errors-container"
    >
      <app-form-error [errorText]="getEditingAmountError()"> </app-form-error>
    </div>
    <app-form-error *ngIf="errorMessage" [errorText]="errorMessage">
    </app-form-error>
  </div>

  <div
    *ngIf="cashoutTask.status == 'PENDING_PAYEE_APPROVAL'"
    class="continue-button-container"
  >
    <zaver-secondary-button-subtle
      text="Cancel payout"
      i18n-text="@@viewCashoutTask.button.cancelPayout"
      [iconUrl]="'assets/icons/Icon-Bin.svg'"
      (click)="cancelCashout()"
    ></zaver-secondary-button-subtle>
  </div>

  <div *ngIf="cashoutTask.status === 'PENDING_ADMIN_APPROVAL'">
    <div
      *ngIf="shouldDisplayAdminApprovalButton() && shouldDisplayCancelButton()"
      class="continue-back-buttons-container"
    >
      <zaver-primary-button
        text="Attest"
        i18n-text="@@viewCashoutTask.button.attest"
        [loading]="sendingApproval"
        (click)="submitAdminAppproval()"
      >
      </zaver-primary-button>
      <zaver-secondary-button-subtle
        text="Cancel payout"
        i18n-text="@@viewCashoutTask.button.cancelPayout"
        [iconUrl]="'assets/icons/Icon-Bin.svg'"
        (click)="cancelCashout()"
        [disabled]="sendingApproval"
      >
      </zaver-secondary-button-subtle>
    </div>
    <div
      *ngIf="!shouldDisplayCancelButton() && shouldDisplayAdminApprovalButton()"
      class="continue-button-container"
    >
      <zaver-primary-button
        text="Attest"
        i18n-text="@@viewCashoutTask.button.attest"
        [loading]="sendingApproval"
        (click)="submitAdminAppproval()"
      >
      </zaver-primary-button>
    </div>
    <div
      *ngIf="!shouldDisplayAdminApprovalButton() && shouldDisplayCancelButton()"
      class="continue-button-container"
    >
      <zaver-secondary-button-subtle
        *ngIf="shouldDisplayCancelButton()"
        text="Cancel payout"
        i18n-text="@@viewCashoutTask.button.cancelPayout"
        [iconUrl]="'assets/icons/Icon-Bin.svg'"
        (click)="cancelCashout()"
      >
      </zaver-secondary-button-subtle>
    </div>
  </div>

  <div *ngIf="cashoutTask.status === 'PENDING_EXECUTION'">
    <div id="editing-button-group">
      <ng-container *ngIf="!editingAmount">
        <zaver-primary-button
          *ngIf="shouldDisplayExecutionButton()"
          text="Pay out"
          i18n-text="@@viewCashoutTask.button.payout"
          (click)="confirmDisbursement()"
        >
        </zaver-primary-button>

        <zaver-secondary-button-subtle
          *ngIf="shouldDisplayEditAmountButton()"
          text="Edit amount"
          i18n-text="@@viewCashoutTask.button.editAmount"
          (click)="editAmount()"
        >
        </zaver-secondary-button-subtle>
      </ng-container>
      <ng-container *ngIf="editingAmount">
        <zaver-primary-button
          text="Update amount"
          i18n-text="@@viewCashoutTask.button.updateAmount"
          [loading]="savingUpdatedAmount"
          (click)="saveEditedAmount()"
        >
        </zaver-primary-button>
        <zaver-secondary-button-subtle
          text="Undo"
          i18n-text="@@viewCashoutTask.button.undo"
          [disabled]="savingUpdatedAmount"
          (click)="undoEditAmount()"
        >
        </zaver-secondary-button-subtle>
      </ng-container>

      <div id="cancel-text-with-icon" *ngIf="shouldDisplayCancelButton()">
        <div id="cancel-click-area" (click)="cancelCashout()">
          <img
            src="assets/icons/Icon-Bin.svg"
            alt="Trashcan icon"
            style="margin-right: 8px"
          />
          <span i18n="@@viewCashoutTask.button.cancelPayout">Cancel payout</span>
        </div>
      </div>
    </div>
  </div>
</div>
